import {
  CommittedOrder,
  GetCommittedOrderRequest,
} from 'planning-portal-library/src/lib/core/domain';

export class SetCommittedOrders {
  static readonly type = '[CommittedOrders] Get Committed Orders';

  constructor(public payload: CommittedOrder[] | undefined) {}
}

export class SetCommittedOrdersRequest {
  static readonly type = '[CommittedOrders] Set Committed Orders';

  constructor(public payload: any | undefined) {}
}
